import { get, isEmpty } from "lodash";
import {
  CREATE_TENANT_START,
  CREATE_TENANT_FAILED,
  CREATE_TENANT_SUCCESS,
  UPDATE_TENANT_START,
  UPDATE_TENANT_SUCCESS,
  UPDATE_TENANT_FAILED,
  EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_START,
  EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_SUCCESS,
  EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_FAILED,
  FETCH_CURRENCY_START,
  FETCH_CURRENCY_FAILED,
  FETCH_CURRENCY_SUCCESS,
  FETCH_CURRENCIES_TENANT_START,
  FETCH_CURRENCIES_TENANT_SUCCESS,
  FETCH_CURRENCIES_TENANT_FAILED
} from "./types";
import NotificationService from "../services/notification.service";
import TenantService from "../services/tenant.service";
import { INVOICE_SERVICES } from "../components/Invoices/constants";
import normalize from "json-api-normalizer";

export const createTenant = (data, vatCountryCode) => async (dispatch, getState) => {
  let anotherCurrency = data.availableCurrencies;
  anotherCurrency = anotherCurrency.concat(data.defaultCurrency);
  delete data.availableCurrencies;

  dispatch({ type: CREATE_TENANT_START });

  try {
    const createTenantResponse = await TenantService.create(data, vatCountryCode);

    const tenantSlug = get(createTenantResponse, "data.data.id");

    await Promise.all(
      anotherCurrency.map(currency => {
        if (!currency.key) return TenantService.createTenantCurrencies(currency, tenantSlug);
        return Promise.resolve(true);
      })
    );
    dispatch({ type: CREATE_TENANT_SUCCESS });
    NotificationService.addSuccess("Tenant successfully created!");
  } catch (e) {
    dispatch({ type: CREATE_TENANT_FAILED });
    NotificationService.addError(`Failed creating tenant ${NotificationService.handleMessage(e)}`);
  }
};

export const updateTenant = (
  data,
  vatCountryCode,
  tenantCurrencies,
  anotherCurrencyState,
  filteredInvoiceAmountCurrency
) => async (dispatch, getState) => {
  dispatch({ type: UPDATE_TENANT_START });
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  delete data.availableCurrencies;

  try {
    await TenantService.update(data, vatCountryCode, tenantSlug);

    if (!isEmpty(anotherCurrencyState)) {
      await Promise.all(
        anotherCurrencyState
          .filter(currency => currency.removed)
          .map(currency => TenantService.deleteTenantCurencies(currency.key, tenantSlug, currency))
      );
    }

    if (!isEmpty(tenantCurrencies)) {
      await Promise.all(
        tenantCurrencies.map(currency => {
          if (!currency.key && !currency.removed) return TenantService.createTenantCurrencies(currency, tenantSlug);
          return Promise.resolve(true);
        })
      );
    }

    if (!isEmpty(filteredInvoiceAmountCurrency)) {
      await Promise.all(
        filteredInvoiceAmountCurrency.map(item => {
          TenantService.updateTenantCurrenciesInvoice(item, tenantSlug);
        })
      );
    }

    dispatch({ type: UPDATE_TENANT_SUCCESS });
    NotificationService.addSuccess("Tenant updated successfully!");
  } catch (e) {
    dispatch({ type: UPDATE_TENANT_FAILED });
    NotificationService.addError(`Failed updating tenant ${NotificationService.handleMessage(e)}`);
  }
};

export const fetchCurrency = () => async dispatch => {
  dispatch({ type: FETCH_CURRENCY_START });
  try {
    const result = await TenantService.getCurrency();
    const normalizedCurrencyData = normalize(result.data);
    dispatch({
      type: FETCH_CURRENCY_SUCCESS,
      payload: normalizedCurrencyData
    });
  } catch (e) {
    dispatch({ type: FETCH_CURRENCY_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch currency data. ${NotificationService.handleMessage(e)}`);
  }
};

export const fetchTenantCurrencies = () => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  dispatch({ type: FETCH_CURRENCIES_TENANT_START });

  try {
    const result = await TenantService.getTenantsCurrency(tenantSlug);
    const normalizedTenantCurrencyData = normalize(result.data);

    dispatch({
      type: FETCH_CURRENCIES_TENANT_SUCCESS,
      payload: normalizedTenantCurrencyData
    });
  } catch (e) {
    dispatch({ type: FETCH_CURRENCIES_TENANT_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch TenantCurrencies data. ${NotificationService.handleMessage(e)}`);
  }
};

export const exportCustomersReport = (exportCustomersReportFor, dateBetween, invoiceType) => async (dispatch, getState) => {
  dispatch({
    type: EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_START
  });

  const tenantSlug = get(getState(), "common.currentTenant.slug");

  try {
    const response = await TenantService.exportCustomersReport(
      tenantSlug,
      exportCustomersReportFor,
      dateBetween,
      invoiceType
    );

    dispatch({
      type: EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_SUCCESS,
      payload: response.data.customers_report || ""
    });

    NotificationService.addSuccess("Customers report successfully exported!");
  } catch (e) {
    dispatch({
      type: EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_FAILED,
      errors: e.response.data.errors
    });

    NotificationService.addError(`Failed exporting customers. ${NotificationService.handleMessage(e)}`);
  }
};
